<p-dialog
  class="filters-modal add-exchange-options-modal"
  header="Agregar exchange"
  [modal]="true"
  [(visible)]="showAddExchangeOptions"
  [style]="{ width: '520px', maxWidth: 'calc(100vw - 32px)' }"
  *ngIf="showAddExchangeOptions"
  (visibleChange)="!$event && close()"
>
  <div class="add-exchange-options">
    <button
      *appHasPlatformService="'exchange:execute'"
      type="button"
      class="exchange-option"
      (click)="openDeclareExchange()"
    >
      <i class="pi pi-file-plus"></i>
      <span>
        <strong>Declarar exchange</strong>
      </span>
    </button>

    <button
      *appHasPlatformService="['exchange:quote', 'exchange:execute']"
      type="button"
      class="exchange-option"
      (click)="openExchangeRateCalculator()"
    >
      <i class="pi pi-calculator"></i>
      <span>
        <strong>Abrir tasador</strong>
      </span>
    </button>
  </div>
</p-dialog>

<p-dialog
  class="filters-modal declare-exchange-modal"
  header="Declarar exchange"
  [modal]="true"
  [(visible)]="showDeclareExchange"
  [style]="{ width: '680px', maxWidth: 'calc(100vw - 32px)' }"
  *ngIf="showDeclareExchange"
  [closable]="!declaringExchange"
  (visibleChange)="!$event && close()"
>
  <div class="filters-container">
    <form
      class="form-container declare-exchange-form"
      [formGroup]="declareExchangeForm"
    >
      <div class="declare-exchange-columns">
        <div class="declare-exchange-column">
          <label>Usuario origen</label>
          <p-dropdown
            [options]="getUserOptions()"
            optionLabel="label"
            optionValue="value"
            formControlName="origin_user_id"
            placeholder="Selecciona usuario origen"
            [filter]="true"
            filterBy="label"
            appendTo="body"
            [disabled]="declaringExchange"
          />

          <label>Moneda origen</label>
          <p-dropdown
            [options]="getCurrencyOptions()"
            optionLabel="label"
            optionValue="value"
            formControlName="origin_currency"
            placeholder="Selecciona moneda origen"
            [filter]="true"
            filterBy="label,value"
            appendTo="body"
            [disabled]="declaringExchange"
          />
          
          <label>Wallet origen</label>
          <p-dropdown
            [options]="getWalletOptions(declareExchangeForm.controls.origin_currency.value || '')"
            optionLabel="label"
            optionValue="id"
            formControlName="origin_wallet_id"
            placeholder="Selecciona wallet origen"
            [filter]="true"
            filterBy="label,id"
            appendTo="body"
            [disabled]="declaringExchange || !declareExchangeForm.controls.origin_currency.value"
          />

          <label>Monto origen</label>
          <p-inputNumber
            formControlName="origin_amount"
            mode="decimal"
            [min]="0"
            [minFractionDigits]="0"
            [maxFractionDigits]="8"
            placeholder="0.00"
            [disabled]="declaringExchange"
          />
        </div>

        <div class="declare-exchange-separator" aria-hidden="true">
          <div class="exchange-separator-line"></div>
          <div class="exchange-separator-icon">
            <i class="pi pi-arrow-right-arrow-left"></i>
          </div>
          <div class="exchange-separator-line"></div>
        </div>

        <div class="declare-exchange-column">
          <label>Usuario destino</label>
          <p-dropdown
            [options]="getUserOptions()"
            optionLabel="label"
            optionValue="value"
            formControlName="destination_user_id"
            placeholder="Selecciona usuario destino"
            [filter]="true"
            filterBy="label"
            appendTo="body"
            [disabled]="declaringExchange"
          />

          <label>Moneda destino</label>
          <p-dropdown
            [options]="getCurrencyOptions()"
            optionLabel="label"
            optionValue="value"
            formControlName="destination_currency"
            placeholder="Selecciona moneda destino"
            [filter]="true"
            filterBy="label,value"
            appendTo="body"
            [disabled]="declaringExchange"
          />

          <label>Wallet destino</label>
          <p-dropdown
            [options]="getWalletOptions(declareExchangeForm.controls.destination_currency.value || '')"
            optionLabel="label"
            optionValue="id"
            formControlName="destination_wallet_id"
            placeholder="Selecciona wallet destino"
            [filter]="true"
            filterBy="label,id"
            appendTo="body"
            [disabled]="declaringExchange || !declareExchangeForm.controls.destination_currency.value"
          />

          <label>Monto destino</label>
          <p-inputNumber
            formControlName="destination_amount"
            mode="decimal"
            [min]="0"
            [minFractionDigits]="0"
            [maxFractionDigits]="8"
            placeholder="0.00"
            [disabled]="declaringExchange"
          />
        </div>
      </div>
    </form>
  </div>

  <div class="buttons-container">
    <p-button
      label="Volver"
      severity="secondary"
      [disabled]="declaringExchange"
      (click)="showOptions()"
    />
    <p-button
      label="Cancelar"
      severity="secondary"
      [disabled]="declaringExchange"
      (click)="close()"
    />
    <p-button
      label="Crear exchange"
      icon="pi pi-check"
      [loading]="declaringExchange"
      [disabled]="declaringExchange || declareExchangeForm.invalid"
      (click)="declareExchange()"
    />
  </div>
</p-dialog>
